exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.text-wrap {\n  min-height: 0.48rem;\n  padding: 0.213333rem 0.346667rem;\n}\n.text-wrap .info {\n  float: left;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-right: 0.16rem;\n}\n.text-wrap .info .title {\n  padding: 0.08rem 0.16rem;\n  border-radius: 0 0.24rem 0.24rem 0;\n  background-color: #e8f1ff;\n  color: #6d98d4;\n}\n.text-wrap .info .ico {\n  font-size: 18px;\n  color: #6d98d4;\n  margin-right: -0.08rem;\n  z-index: 1;\n}\n.text-wrap .brief {\n  font-size: 15px;\n  line-height: 0.506667rem;\n  color: #999;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?importLoaders=1?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-72f5aaf7","scoped":false,"hasInlineConfig":false}!./node_modules/px2rem-loader?{"remUnit":37.5,"baseDpr":1}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/VText.vue
// module id = 4Zmk
// module chunks = 11